import { useEffect } from 'react'
import { onMessage } from 'firebase/messaging'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter, Navigate, Outlet, Routes } from 'react-router-dom'
import { Route } from 'use-react-router-breadcrumbs'
import { load } from '@fingerprintjs/fingerprintjs'
import type { UserProps } from 'modules/types'
import { getFcmToken, messaging } from 'modules/firebase'
import { type AppDispatch } from 'store/api.store'
import './App.scss'
import { setDeviceId, setFcmToken } from 'store/firebase.slice'
import CampaignEvent from 'pages/campaign/event/page'
import Campaign from 'pages/campaign/page'
import CampaignStory from 'pages/campaign/story/page'
import EVCarBrand from 'pages/catalog/evmodel/carBrand/page'
import EVCarBrandCatalog from 'pages/catalog/evmodel/carCatalog/page'
import EVCarModel from 'pages/catalog/evmodel/page'
import HyundaiCarCatalog from 'pages/catalog/hyundaimodel/carCatalog/page'
import HyundaiCarModelList from 'pages/catalog/hyundaimodel/carModel/page'
import HyundaiCarModel from 'pages/catalog/hyundaimodel/page'
import PromoCode from 'pages/promo/code/page'
import Promo from 'pages/promo/page'
import VoucherCategory from 'pages/voucher/category/category/page'
import Category from 'pages/voucher/category/page'
import VoucherSubCategory from 'pages/voucher/category/subcategory/page'
import Voucher from 'pages/voucher/page'
import TokenCategory from 'pages/voucher/token/category/page'
import TokenImportList from 'pages/voucher/token/import/main/page'
import TokenImport from 'pages/voucher/token/import/page'
import TokenImportSub from 'pages/voucher/token/import/sub/page'
import TokenList from 'pages/voucher/token/list/page'
import Token from 'pages/voucher/token/page'
import TokenRequestMain from 'pages/voucher/token/request/main/page'
import TokenRequest from 'pages/voucher/token/request/page'
import TokenRequestSub from 'pages/voucher/token/request/sub/page'
import VoucherList from 'pages/voucher/voucher/page'
import './App.scss'
// import EventCampaign from 'pages/campaign/event/campaign/page'
// import EventChallenge from 'pages/campaign/event/challenge/page'
// import EventTransaction from 'pages/campaign/event/transaction/page'
// import EventRegistration from 'pages/campaign/event/registration/page'
// import ChallengeList from 'pages/campaign/event/challenge/challenge/page'
// import ChallengeActivity from 'pages/campaign/event/challenge/activity/page'
// import ChallengeSubActivity from 'pages/campaign/event/challenge/subActivity/page'
// import RegistrationTestDrive from 'pages/campaign/event/registration/testDrive/page'
// import RegistrationTransaction from 'pages/campaign/event/registration/transaction/page'
import PromoRedemption from 'pages/promo/redemption/page'
// import RegistrationSingleGame from 'pages/campaign/event/registration/singleGame/page'
import PromoBatchCategory from 'pages/promo/batch/category/page'
import PromoBatch from 'pages/promo/batch/page'
// import EventPrizeList from 'pages/campaign/event/prize/prize/page'
// import EventPrize from 'pages/campaign/event/prize/page'
// import EventPrizeRedemption from 'pages/campaign/event/prize/redemption/page'
import {
  default as BookCarServiceTransaction,
  default as BookCarServiceTransactionList
} from 'pages/bookCarServiceTransaction/list/page'
import Banner from 'pages/campaign/event/serviceBooking/banner/page'
import ServiceBooking from 'pages/campaign/event/serviceBooking/page'
import Transaction from 'pages/campaign/event/serviceBooking/transaction/page'
import Coin from 'pages/coin/page'
import CoinSubmission from 'pages/coin/submission/page'
import NotificationCustomerEmail from 'pages/notification/customer/email/page'
import NotificationCustomer from 'pages/notification/customer/page'
import NotificationCustomerPhone from 'pages/notification/customer/phone/page'
import NotificationCustomerPush from 'pages/notification/customer/push-notif/page'
import Notification from 'pages/notification/page'
import PromoBatchList from 'pages/promo/batch/list/page'
import VoucherBenefits from 'pages/voucher/benefits/page'
import VoucherFAQ from 'pages/voucher/faq/page'
import VoucherGift from 'pages/voucher/gift/page'
import VoucherPackage from 'pages/voucher/package/page'
import GiftRedemption from 'pages/voucher/redemption/page'
import VoucherUsageList from 'pages/voucher/usage/list/page'
import VoucherUsage from 'pages/voucher/usage/page'
import VoucherUsageTokenList from 'pages/voucher/usage/token/page'
import UserPage from 'pages/user/page'
import UserListPage from 'pages/user/list/page'
import BannerPage from 'pages/banner/page'
import DailyCheckinPage from 'pages/dailycheckin/page'
import DailyCheckinList from 'pages/dailycheckin/list/page';
import Dashboard from 'pages/dashboard/page';
import WhatsGoingOnPage from 'pages/whatsgoingon/page'
import WhatsGoingOnList from 'pages/whatsgoingon/list/page'
import OneStopHyundaiPage from 'pages/homepage/one-stop-hyundai/page'
import ResaleValueGuaranteeList from 'pages/profiling/resale-value-guarantee/page'
import TradeInList from 'pages/profiling/trade-in/page'
import TestDriveList from 'pages/profiling/test-drive/page'
import PopUpBannerList from 'pages/pop-up-banner/page'
import CarInterestList from 'pages/profiling/car-interest/page'
import GetAnOfferList from 'pages/profiling/get-an-offer/page'
import ReferralList from 'pages/profiling/referral/page'
import ReferralOwnerList from 'pages/profiling/referral-owner/page'
import Guard from './Guard'
import NoRoute from './pages/404/404'
import Catalog from './pages/catalog/page'
import OtherBrandUsers from './pages/ev/otherbrand/page'
import EV from './pages/ev/page'
import Assignment from './pages/identity/assignment/page'
import Access from './pages/identity/control/access/page'
import Account from './pages/identity/control/account/page'
import Check from './pages/identity/control/check/page'
import Control from './pages/identity/control/page'
import Identity from './pages/identity/page'
import Roles from './pages/identity/roles/page'
import Layout from './pages/layout/page'
import Login from './pages/login/page'
import LoginOtp from './pages/loginOtp/page'
import FaqCategory from './pages/master/faq/category/page'
import FAQList from './pages/master/faq/list/page'
import FAQ from './pages/master/faq/page'
import Dealer from './pages/master/location/dealer/page'
import Event from './pages/master/location/event/page'
import Location from './pages/master/location/page'
import PartnerCategory from './pages/master/location/partner/category/page'
import PartnerList from './pages/master/location/partner/list/page'
import Partner from './pages/master/location/partner/page'
import Master from './pages/master/page'
import PrivacyPolicy from './pages/master/privacy/page'
import RegionData from './pages/master/region/data/page'
import RegionDMS from './pages/master/region/dms/page'
import Region from './pages/master/region/page'
import TermsAndCondition from './pages/master/terms/page'
import CarInformation from './pages/profiling/carinformation/page'
import CarInformationList from './pages/profiling/carinformation/list/page'
import CarInjection from './pages/profiling/carinformation/injection/page'
import Profiling from './pages/profiling/page'
import PushNotificationList from './pages/pushNotification/list/page'
import PushNotification from './pages/pushNotification/page'
import CityLounge from './pages/voucher-booking/garuda/city-lounge/page'
import Garuda from './pages/voucher-booking/garuda/page'
import VoucherBooking from './pages/voucher-booking/page'
import Inbox from './pages/inbox/page'
import InboxList from './pages/inbox/list/page'
import ConfigItem from './pages/config/page'
import ConfigItemList from './pages/config/page'
import PopUpBanner from './pages/pop-up-banner/page'

export const GenerateAppRoutes = () => {
  const permissions = useSelector((state: { user: UserProps }) => state.user.user.permissions)
  return (
  <Routes>
    <Route path='/' element={<Guard component={<Layout />} />}>
      <Route path='master' element={<Guard component={<Master />} />}>
        <Route path='region' element={<Guard component={<Region />} />}>
          <Route path='data' element={<Guard component={<RegionData />} />} />
          <Route path='dms' element={<Guard component={<RegionDMS />} />} />
        </Route>
        <Route path='faq' element={<Guard component={<FAQ />} />}>
          <Route index path=':language' element={<Guard component={<FaqCategory />} />} />
          <Route path=':language/:key' element={<Guard component={<FAQList />} />} />
        </Route>
        <Route path='faq' element={<Guard component={<FAQ />} />}>
          <Route index path='' element={<Guard component={<FaqCategory />} />} />
          <Route path=':key' element={<Guard component={<FAQList />} />} />
        </Route>
        <Route path='terms' element={<Guard component={<TermsAndCondition />} />} />
        <Route path='privacy' element={<Guard component={<PrivacyPolicy />} />} />
        <Route path='location' element={<Guard component={<Location />} />}>
          <Route path='dealer' element={<Guard component={<Dealer />} />} />
          <Route path='partner' element={<Guard component={<Partner />} />}>
            <Route index path='' element={<Guard component={<PartnerCategory />} />} />
            <Route path=':key' element={<Guard component={<PartnerList />} />} />
          </Route>
          <Route path='event' element={<Guard component={<Event />} />} />
        </Route>
      </Route>
      <Route path='ev' element={<Guard component={<EV />} />}>
        {/* <Route path='charge' element={<Guard component={<EVCharge />} />}>
                    <Route path='point' element={<Guard component={<EVChargePoint />} />}>
                        <Route index path='' element={<Guard component={<EVChargePointList />} />} />
                        <Route path=':id' element={<Guard component={<EVChargePointListGroup />} />} />
                        <Route path=':id/:key' element={<Guard component={<EVChargePointListBoxGroup />} />} />
                    </Route>
                    <Route path='box' element={<Guard component={<EVChargeBox />} />}>
                        <Route index path='' element={<Guard component={<EVChargeBoxList />} />} />
                        <Route path=':key' element={<Guard component={<EVChargeBoxGroup />} />} />
                    </Route>
                </Route>
                <Route path='topup' element={<Guard component={<EVTopup />} />} />
                <Route path='price' element={<Guard component={<EVPrice />} />}>
                    <Route index path='' element={<Guard component={<EVPriceList />} />} />
                    <Route path=':id' element={<Guard component={<EVPriceChargerBoxGroup />} />} />
                </Route>
                <Route path='transaction' element={<Guard component={<EVTransaction />} />}>
                    <Route path='ongoing' element={<Guard component={<EVTransactionOngoing />} />}>
                        <Route index path='' element={<Guard component={<EVTransactionOngoingList />} />} />
                        <Route path=':id' element={<Guard component={<EVTransactionLog />} />} />
                    </Route>
                    <Route path='finished' element={<Guard component={<EVTransactionFinished />} />}>
                        <Route index path='' element={<Guard component={<EVTransactionFinishedList />} />} />
                        <Route path=':id' element={<Guard component={<EVTransactionLog />} />} />
                    </Route>
                </Route>
                <Route path='policy' element={<Guard component={<EVPolicy />} />}>
                    <Route path='charger' element={<Guard component={<EVPolicyCharger />} />} />
                    <Route path='partner' element={<Guard component={<EVPartnerVoucher />} />} />
                    <Route path='qrcode' element={<Guard component={<EVQrCode />} />} />R
                </Route>
                <Route path='location' element={<Guard component={<EvLocation />} />} />
                <Route path='charger' element={<Guard component={<EvType />} />} />
                <Route path='partner' element={<Guard component={<EVPartner />} />} />
                <Route path='dashboard' element={<Guard component={<EVPartnerDashboard />} />}>
                    <Route path='history' element={<Guard component={<EVTransactionHistory />} />} />
                    <Route path='overview' element={<Guard component={<EVOverview />} />} />
                    <Route path='request' element={<Guard component={<EVRequest />} />} />
                </Route>
                <Route path='history' element={<Guard component={<EVHistory />} />}>
                    <Route path='overview' element={<Guard component={<EVHistoryOverview />} />} />
                    <Route path='ongoing' element={<Guard component={<EVHistoryOngoing />} />}>
                        <Route index path='' element={<Guard component={<EVHistoryOngoingList />} />} />
                        <Route path=':id' element={<Guard component={<EVTransactionLog />} />} />
                    </Route>
                    <Route path='finished' element={<Guard component={<EVHistoryFinished />} />}>
                        <Route index path='' element={<Guard component={<EVHistoryFinishedList />} />} />
                        <Route path=':id' element={<Guard component={<EVTransactionLog />} />} />
                    </Route>
                </Route>
                <Route path='charging' element={<Guard component={<EVCharging />} />} /> */}
        <Route path='otherbrandusers' element={<Guard component={<OtherBrandUsers />} />} />
        <Route path='brand' element={<Guard component={<EVCarModel />} />}>
          <Route index path='' element={<Guard component={<EVCarBrand />} />} />
          <Route path=':name' element={<Guard component={<EVCarBrandCatalog />} />} />
        </Route>
      </Route>
      <Route path='catalog' element={<Guard component={<Catalog />} />}>
        <Route path='hyundai' element={<Guard component={<HyundaiCarModel />} />}>
          <Route index path='' element={<Guard component={<HyundaiCarModelList />} />} />
          <Route path=':key' element={<Guard component={<HyundaiCarCatalog />} />} />
        </Route>
        <Route path='brand' element={<Guard component={<EVCarModel />} />}>
          <Route index path='' element={<Guard component={<EVCarBrand />} />} />
          <Route path=':name' element={<Guard component={<EVCarBrandCatalog />} />} />
        </Route>
      </Route>
      <Route path='profiling' element={<Guard component={<Profiling />} />}>
        <Route path='carinformation' element={<Guard component={<CarInformation />} />}>
          <Route path='list' element={<Guard component={<CarInformationList />} />} />
          <Route path='injection' element={<Guard component={<CarInjection />} />} />
        </Route>
        <Route
          path='resale-value-guarantee'
          element={<Guard component={<ResaleValueGuaranteeList />} />}
        />
        <Route path='trade-in' element={<Guard component={<TradeInList />} />} />
        <Route path='car-interest' element={<Guard component={<CarInterestList />} />} />
        <Route path='get-an-offer' element={<Guard component={<GetAnOfferList />} />} />
        <Route path='test-drive' element={<Guard component={<TestDriveList />} />} />
      </Route>
      <Route path='referral' element={<Guard component={<Outlet />} />}>
        <Route path='referral-purchase' element={<Guard component={<ReferralList />} />} />
        <Route path='referral-owner' element={<Guard component={<ReferralOwnerList />} />} />
      </Route>
      <Route path='user' element={<Guard component={<UserPage />} />}>
        <Route path='list' element={<Guard component={<UserListPage />} />} />
      </Route>
      <Route path='identity' element={<Guard component={<Identity />} />}>
        <Route path='control' element={<Guard component={<Control />} />}>
          <Route path='account' element={<Guard component={<Account />} />} />
          <Route path='access' element={<Guard component={<Access />} />} />
          <Route path='check' element={<Guard component={<Check />} />} />
        </Route>
        <Route path='roles' element={<Guard component={<Roles />} />} />
        <Route path='assignment' element={<Guard component={<Assignment />} />} />
      </Route>
      <Route path='voucher' element={<Guard component={<Voucher />} />}>
        <Route path='list' element={<Guard component={<VoucherList />} />} />
        <Route path='faq' element={<Guard component={<VoucherFAQ />} />} />
        <Route path='usage' element={<Guard component={<VoucherUsage />} />}>
          <Route index path='' element={<Guard component={<VoucherUsageList />} />} />
          <Route index path=':id' element={<Guard component={<VoucherUsageTokenList />} />} />
        </Route>
        <Route path='category' element={<Guard component={<Category />} />}>
          <Route index path='' element={<Guard component={<VoucherCategory />} />} />
          <Route path=':key' element={<Guard component={<VoucherSubCategory />} />} />
        </Route>
        <Route path='gift' element={<Guard component={<VoucherGift />} />} />
        <Route path='redemption' element={<Guard component={<GiftRedemption />} />} />
        <Route path='token' element={<Guard component={<Token />} />}>
          <Route index path='list' element={<Guard component={<TokenList />} />} />
          <Route path='category' element={<Guard component={<TokenCategory />} />} />
          <Route path='request' element={<Guard component={<TokenRequest />} />}>
            <Route index path='' element={<Guard component={<TokenRequestMain />} />} />
            <Route path=':key' element={<Guard component={<TokenRequestSub />} />} />
          </Route>
          <Route path='import' element={<Guard component={<TokenImport />} />}>
            <Route index path='' element={<Guard component={<TokenImportList />} />} />
            <Route path=':key' element={<Guard component={<TokenImportSub />} />} />
          </Route>
        </Route>
        <Route path='benefits' element={<Guard component={<VoucherBenefits />} />} />
        <Route path='package' element={<Guard component={<VoucherPackage />} />} />
      </Route>
      <Route path='promo' element={<Guard component={<Promo />} />}>
        <Route index path='code' element={<Guard component={<PromoCode />} />} />
        <Route index path='redemption' element={<Guard component={<PromoRedemption />} />} />
        <Route path='batch' element={<Guard component={<PromoBatch />} />}>
          <Route index path='' element={<Guard component={<PromoBatchCategory />} />} />
          <Route path=':key' element={<Guard component={<PromoBatchList />} />} />
        </Route>
      </Route>
      <Route path='campaign' element={<Guard component={<Campaign />} />}>
        <Route path='event' element={<Guard component={<CampaignEvent />} />}>
          {/* <Route path='campaign' element={<Guard component={<EventCampaign />} />} /> */}
          {/* <Route path='challenge' element={<Guard component={<EventChallenge />} />}>
            <Route path='list' element={<Guard component={<ChallengeList />} />} />
            <Route path='activity' element={<Guard component={<ChallengeActivity />} />} />
            <Route path='subactivity' element={<Guard component={<ChallengeSubActivity />} />} />
          </Route>
          <Route path='transaction' element={<Guard component={<EventTransaction />} />} />
          <Route path='registration' element={<Guard component={<EventRegistration />} />}>
            <Route path='test' element={<Guard component={<RegistrationTestDrive />} />} />
            <Route path='game' element={<Guard component={<RegistrationSingleGame />} />} />
            <Route path='transaction' element={<Guard component={<RegistrationTransaction />} />} />
          </Route>
          <Route path='prize' element={<Guard component={<EventPrize />} />}>
            <Route path='list' element={<Guard component={<EventPrizeList />} />} />
            <Route path='redemption' element={<Guard component={<EventPrizeRedemption />} />} />
          </Route> */}
          <Route path='service-booking' element={<Guard component={<ServiceBooking />} />}>
            <Route
              path='banner'
              element={<Guard component={<Banner module='service-event' />} />}
            />
            <Route path='booking-history' element={<Guard component={<Transaction />} />} />
          </Route>
        </Route>
        <Route path='story' element={<Guard component={<CampaignStory />} />} />
      </Route>
      <Route path='coin' element={<Guard component={<Coin />} />}>
        <Route path='submission' element={<Guard component={<CoinSubmission />} />} />
      </Route>
      <Route path='notification' element={<Guard component={<Notification />} />}>
        <Route path='customer' element={<Guard component={<NotificationCustomer />} />}>
          <Route path='email' element={<Guard component={<NotificationCustomerEmail />} />} />
          <Route path='phone' element={<Guard component={<NotificationCustomerPhone />} />} />
          <Route path='push-notif' element={<Guard component={<NotificationCustomerPush />} />} />
        </Route>
      </Route>
      <Route path='voucher-booking' element={<Guard component={<VoucherBooking />} />}>
        <Route path='garuda' element={<Guard component={<Garuda />} />}>
          <Route path='city-lounge' element={<Guard component={<CityLounge />} />} />
        </Route>
      </Route>
      <Route
        path='book-car-service-transaction'
        element={<Guard component={<BookCarServiceTransaction />} />}
      >
        <Route
          path='book-car-service-transaction-list'
          element={<Guard component={<BookCarServiceTransactionList />} />}
        />
      </Route>
      <Route path='push-notification' element={<Guard component={<PushNotification />} />}>
        <Route path='list' element={<Guard component={<PushNotificationList />} />} />
      </Route>
      <Route path='inbox' element={<Guard component={<Inbox />} />}>
        <Route index path='list' element={<Guard component={<InboxList />} />} />
      </Route>
      <Route path='banner' element={<Guard component={<BannerPage />} />}>
        <Route index element={<Navigate to='list' replace />} />
        <Route path='list' element={<Guard component={<Banner module='banner' placement='HomePage' />} />} />
        <Route
          path='service-accessories'
          element={<Guard component={<Banner module='banner' placement='ServiceAccessories' />} />}
        />
        <Route
          path='customer-care'
          element={<Guard component={<Banner module='banner' placement='CustomerCare' />} />}
        />
      </Route>
      <Route path='config' element={<Guard component={<ConfigItem />} />}>
        <Route path='list' element={<Guard component={<ConfigItemList />} />} />
      </Route>
      <Route path='dailycheckin' element={<Guard component={<DailyCheckinPage />} />}>
        <Route path='list' element={<Guard component={<DailyCheckinList />} />} />
      </Route>
      <Route path='homepage' element={<Guard component={<Outlet />} />}>
        <Route path='one-stop-hyundai' element={<Guard component={<OneStopHyundaiPage />} />} />
      </Route>
      <Route path='whatsgoingon' element={<Guard component={<WhatsGoingOnPage />} />}>
        <Route path='list' element={<Guard component={<WhatsGoingOnList />} />} />
      </Route>
      <Route path='pop-up-banner' element={<Guard component={<PopUpBanner />} />}>
        <Route path='list' element={<Guard component={<PopUpBannerList />} />} />
      </Route>
      {permissions.includes('READ_DASHBOARD') && <Route path='/' element={<Dashboard />} />}
      <Route path='*' element={<NoRoute />} />
    </Route>
    <Route path='/login' element={<Login />} />
    <Route path='/login-otp' element={<LoginOtp />} />
  </Routes>
  )
}

const App = () => {
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    async function getDeviceId() {
      const visitorId = (await (await load()).get()).visitorId
      dispatch(setDeviceId(visitorId))
    }

    async function requestNotificationPermission() {
      if ('Notification' in window) {
        const permission = await window.Notification.requestPermission()

        if (permission === 'granted') {
          console.log('Notification permission granted.')

          try {
            const fcmToken = await getFcmToken()
            dispatch(setFcmToken(fcmToken))
          } catch (error) {
            console.error('Failed to get FCM token:', error)
          }
        } else {
          console.log('Unable to get permission to notify.')
        }
      }
    }

    getDeviceId()
    requestNotificationPermission()

    onMessage(messaging, (payload) => {
      new window.Notification(payload.notification?.title || '', {
        body: payload.notification?.body || '',
        icon: '/logo_myHyundai.png'
      })
    })
  }, [])
  return (
    <BrowserRouter>
      <GenerateAppRoutes />
    </BrowserRouter>
  )
}

export default App
